import type { DataCoverage } from "@/lib/data-coverage";

/** Read-only page top. Never contains blocks, account settings or edit rights. */
export type WorkspaceDocumentMetadata = {
  identity: string;
  pageId: string;
  title: string;
  icon: string;
  description: string;
  changedAt: number;
  coverage: DataCoverage | null;
  store: { name: string; pinned: boolean } | null;
  hasCover: boolean;
  cover?: string;
  fullWidth?: boolean;
};

/** A response for another account/page must not become even a read-only preview. */
export function matchingWorkspaceDocumentMetadata(value: WorkspaceDocumentMetadata | null, identity: string, pageId: string | null) {
  return value?.identity === identity && value.pageId === pageId ? value : null;
}
